var form = {};

function checkbox() {
	var check = function($this) {
		var $parent = $this.closest('.frm_checkbox');
		if ($this.is(':checked')) {
			$parent.addClass('is-active');
		} else {
			$parent.removeClass('is-active');
		}
	}
	$('.frm_forms .frm_checkbox input[type="checkbox"]').each(function(e) {
		check($(this));
	});
	$('.frm_forms .frm_checkbox input[type="checkbox"]').unbind('change').change(function(e) {
		check($(this));
	});
}

function radio() {
	var check = function($this) {
		var $parent = $this.closest('.frm_radio'),
				$group = $this.closest('.frm_form_field');
		$group.find('.frm_radio').removeClass('is-active');
		if ($this.is(':checked')) {
			$parent.addClass('is-active');
		}
	}
	$('.frm_forms .frm_radio input[type="radio"]').each(function(e) {
		check($(this));
	});
	$('.frm_forms .frm_radio input[type="radio"]').unbind('change').change(function(e) {
		check($(this));
	});
}

function compare() {
	var check = function($this) {
		var $parent  = $this.closest('.item-wrap'),
				$group   = $this.closest('.block-compare');
		$group.find('.item-wrap').removeClass('is-active');
		if ($this.is(':checked')) {
			$parent.addClass('is-active');
		}
	}
	var toggle = function($this) {
		if ( 'undefined' == typeof $this ) {
			var $this = $('.frm_forms .item-wrap input[type="radio"]:checked').closest('.item-wrap');
		}
		var $show = $this.closest('.item-wrap').attr('data-section');

		if ( 'undefined' != typeof $show ) {

			var $form_id = $this.closest('form').find('input[name="form_id"]').val();
			var $hidden_hide_field_id = 'frm_hide_fields_' + $form_id;
			var $hidden_hide_field = $this.closest('form').find('input[name="' + $hidden_hide_field_id + '"]').val();

			var arr = [];
			if ( 'undefined' != typeof $hidden_hide_field && '' !== $hidden_hide_field ) {
				arr = JSON.parse( $hidden_hide_field );
			}

			$('.frm_forms .item-wrap input[type="radio"]').each(function(e) {
				var $hide = $(this).closest('.item-wrap').attr('data-section');

				if ( $show == $hide ) {
					$('.frm_section_heading.section-' + $hide ).show();
					// toggle hidden fields
					let remove = $('.frm_section_heading.section-' + $hide ).attr('id');
					var index = arr.indexOf( remove );
					if ( index > -1 ) {
						arr.splice( index, 1 );
					}
				} else {
					$('.frm_section_heading.section-' + $hide ).hide();
					let add = $('.frm_section_heading.section-' + $hide ).attr('id');
					if ( arr.indexOf( add ) == -1 ) {
						arr[ arr.length ] = add;
					}
				}
			});
			// update hidden field (if any)
			setTimeout(function(){
				$this.closest('form').find('input[name="' + $hidden_hide_field_id + '"]').val( JSON.stringify( arr ) );
			}, 500);
		} else {
			$('.frm_section_heading[class*="section-"]').hide();
		}
	}
	$('.frm_forms .item-wrap input[type="radio"]').each(function(e) {
		check($(this));
	});
	$('.frm_forms .item-wrap input[type="radio"]').unbind('change').change(function(e) {
		check($(this));
		toggle($(this));
	});
	toggle();
}

function scale() {
	var check = function($this) {
		var $parent = $this.closest('.frm_scale'),
				$group = $this.closest('.frm_form_field');
		$group.find('.frm_scale').removeClass('is-active');
		if ($this.is(':checked')) {
			$parent.addClass('is-active');
		}
	}
	$('.frm_forms .frm_scale input[type="radio"]').each(function(e) {
		check($(this));
	});
	$('.frm_forms .frm_scale input[type="radio"]').unbind('change').change(function(e) {
		check($(this));
	});
}

form.init = function() {
	checkbox();
	radio();
	compare();
	scale();
}

export { form };
